import IComponentSelectProps from 'interfaces/IComponentSimpleProps';

import { ReduxStore } from 'store/types';

function getAllToSelectList(state: ReduxStore): IComponentSelectProps[] {
  return state.category.getAllToSelect.list;
}

export default getAllToSelectList;
